import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X, Phone, Calendar } from 'lucide-react';
import { mockData } from '../mock';

export const Header = ({ onContactClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { label: 'Services', href: '#services' },
    { label: 'À propos', href: '#about' },
    { label: 'Zone', href: '#zone' },
    { label: 'Témoignages', href: '#testimonials' },
    { label: 'Devis', href: '/devis' },
    { label: 'Contact', href: '#contact' }
  ];

  const scrollToSection = (href) => {
    // Check if it's a route link
    if (href.startsWith('/')) {
      window.location.href = href;
      setIsMenuOpen(false);
      return;
    }
    
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    } else if (href === '#contact') {
      onContactClick();
      setIsMenuOpen(false);
    }
  };

  const openCalendly = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({ url: 'https://calendly.com/taiebnatana/30min' });
    }
    return false;
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-stone-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3 group">
            <img 
              src="/logo.jpeg" 
              alt="MonDiagImmo" 
              className="w-12 h-12 rounded-full shadow-md group-hover:scale-110 transition-transform" 
            />
            <span className="text-2xl font-bold bg-gradient-to-r from-stone-900 to-emerald-900 bg-clip-text text-transparent whitespace-nowrap">
              MonDiagImmo
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <button
                key={item.label}
                onClick={() => scrollToSection(item.href)}
                className="text-stone-700 hover:text-emerald-700 font-medium transition-colors duration-200 relative group"
              >
                {item.label}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-emerald-700 transition-all duration-300 group-hover:w-full" />
              </button>
            ))}
          </nav>

          {/* Desktop CTAs */}
          <div className="hidden md:flex items-center gap-3">
            <Button 
              onClick={openCalendly}
              className="bg-emerald-700 hover:bg-emerald-800 text-white rounded-full px-6 shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105"
            >
              <Calendar className="mr-2 w-4 h-4" />
              Prendre RDV
            </Button>
            <Button 
              onClick={onContactClick}
              variant="outline"
              className="border-2 border-emerald-700 text-emerald-700 hover:bg-emerald-50 rounded-full px-6 transition-all duration-300"
            >
              <Phone className="mr-2 w-4 h-4" />
              Devis gratuit
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-stone-100 transition-colors"
          >
            {isMenuOpen ? (
              <X className="w-6 h-6 text-stone-900" />
            ) : (
              <Menu className="w-6 h-6 text-stone-900" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden py-6 border-t border-stone-200 animate-fade-in">
            <div className="flex flex-col gap-4">
              {navItems.map((item) => (
                <button
                  key={item.label}
                  onClick={() => scrollToSection(item.href)}
                  className="text-left text-stone-700 hover:text-emerald-700 font-medium transition-colors py-2 px-4 rounded-lg hover:bg-stone-50"
                >
                  {item.label}
                </button>
              ))}
              <Button 
                onClick={() => {
                  openCalendly();
                  setIsMenuOpen(false);
                }}
                className="mt-2 bg-emerald-700 hover:bg-emerald-800 text-white rounded-full shadow-md"
              >
                <Calendar className="mr-2 w-4 h-4" />
                Prendre RDV
              </Button>
              <Button 
                onClick={() => {
                  onContactClick();
                  setIsMenuOpen(false);
                }}
                variant="outline"
                className="border-2 border-emerald-700 text-emerald-700 hover:bg-emerald-50 rounded-full"
              >
                <Phone className="mr-2 w-4 h-4" />
                Devis gratuit
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};